import React from 'react';
import {defineMessages} from 'react-intl';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ListItemText} from '@mui/material';

const localized = defineMessages({
    main: {
        id: 'AddRepaymentLogReminderModal_main',
        defaultMessage: 'The repayment entry has been saved. Please complete the remaining flows:',
    },
    item1: {
        id: 'AddRepaymentLogReminderModal_item1',
        defaultMessage: "Deduct repayment amount from the downline agent's weekly revenue share.",
    },
    item2: {
        id: 'AddRepaymentLogReminderModal_item2',
        defaultMessage: 'Credit the repayment amount manually to the master agent.',
    },
});

export function AddRepaymentLogReminderModal() {
    return (
        <div>
            <LocalizedText label={localized.main} />
            <ul>
                <li>
                    <ListItemText>
                        <LocalizedText label={localized.item1} />
                    </ListItemText>
                </li>
                <li>
                    <ListItemText>
                        <LocalizedText label={localized.item2} />
                    </ListItemText>
                </li>
            </ul>
        </div>
    );
}
